import React, { useMemo } from 'react';
import CryptoJS from 'crypto-js';
import { CentreList } from '../../user_constant';

const WelcomePage: React.FC = () => {
  const params = new URLSearchParams(window.location.search);
  const centreParam = params.get('centre');

  const centreName = useMemo(() => {
    if (!centreParam) return 'Care Concierge'; // Default fallback

    try {
        const encKey = "CareConcierge";
        
        // 1. Decrypt the string from the URL
        const bytes = CryptoJS.AES.decrypt(centreParam, encKey);
        const decryptedId = bytes.toString(CryptoJS.enc.Utf8);

        // 2. Find the matching centre in your list
        // Note: decryptedId is a string, so we convert it to a Number
        const match = CentreList.find(item => item.value === Number(decryptedId));

        console.log(match)

        // 3. Return the name if found, otherwise default
        return match ? match.centreName : 'Care Concierge';
        
    } catch (error) {
        console.error("Failed to decrypt centre ID:", error);
        return 'Care Concierge';
    }
}, [centreParam]);

  return (
    // Wrapper to break out of parent padding and create a full-bleed, immersive effect
    <div className="relative -m-6 sm:-m-8 h-[calc(100%+3rem)] sm:h-[calc(100%+4rem)] flex items-center justify-center overflow-hidden rounded-2xl animate-fade-in">
      
      {/* Background Image */}
      <div 
        className="absolute inset-0 w-full h-full bg-cover bg-center transition-transform duration-500 ease-in-out scale-105"
        style={{ backgroundImage: "url('https://mycareconcierge.com/wp-content/uploads/2024/10/05_02907-scaled.jpg')" }}
        aria-hidden="true"
      ></div>

      {/* Gradient Overlay */}
      <div className="absolute inset-0 bg-gradient-to-br from-brand-primary/70 via-slate-900/60 to-slate-900/80"></div>
      
      {/* Content */}
      <div className="relative z-10 text-center text-white p-8">
        <div className="animate-fade-in-up">
          <h1 className="text-4xl md:text-6xl font-extrabold tracking-tight" style={{ textShadow: '2px 2px 8px rgba(0,0,0,0.5)' }}>
            Welcome to {centreName}
          </h1>
          <p className="mt-4 text-lg md:text-2xl text-slate-200 max-w-2xl mx-auto" style={{ textShadow: '1px 1px 4px rgba(0,0,0,0.6)' }}>
            For the quality of life and wellness you deserve.
          </p>
        </div>

        <div className="w-24 h-px bg-white/40 mx-auto my-10 animate-fade-in-up" style={{ animationDelay: '200ms' }}></div>
        
        <div className="max-w-xl mx-auto animate-fade-in-up" style={{ animationDelay: '400ms' }}>
            <h2 className="text-xl md:text-2xl font-bold text-white">
                Explore a New Lifestyle
            </h2>
            <p className="mt-3 text-slate-300">
                Comprehensive Senior Care and Integrated Community Living. We care about you and your loved ones.
            </p>
        </div>
      </div>

    </div>
  );
};

export default WelcomePage;
